import { atom } from 'jotai';

const DEFAULT_LOWER_LIMIT = 1;
const DEFAULT_UPPER_LIMIT = 100;

const globalFilterModeAtom = atom('index');

const mergeLimits = (oldLimits, newLimits) => ({
  ...oldLimits,
  low: Number.isNaN(newLimits.low) ? DEFAULT_LOWER_LIMIT : newLimits.low,
  high: Number.isNaN(newLimits.high) ? DEFAULT_UPPER_LIMIT : newLimits.high,
});

const tempLimitsAtom = atom({
  low: DEFAULT_LOWER_LIMIT,
  high: DEFAULT_UPPER_LIMIT,
});

const limitsAtom = atom(
  get => get(tempLimitsAtom),
  (get, set, limits) =>
    set(tempLimitsAtom, mergeLimits(get(tempLimitsAtom), limits)),
);

const datesAtom = atom({
  start: new Date(),
  end: new Date(),
});

export { globalFilterModeAtom, limitsAtom, datesAtom };
